import { render } from "./Assignments.vue?vue&type=template&id=ce1561da&scoped=true"
import script from "./Assignments.vue?vue&type=script&lang=js"
export * from "./Assignments.vue?vue&type=script&lang=js"

import "./Assignments.vue?vue&type=style&index=0&id=ce1561da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce1561da"]])

export default __exports__